import { apiRequest } from '../api/http';
import { appUrl } from '../config/appUrl';
import { readTokens } from './tokens';

export function isAppDestination(href: string): boolean {
  try {
    const url = new URL(href, window.location.origin);
    return url.origin === new URL(appUrl()).origin && url.pathname !== '/auth/handoff';
  } catch { return false; }
}

let navigating = false;
export async function navigateToApp(path = '/'): Promise<void> {
  if (navigating) return;
  const destination = new URL(path, appUrl());
  if (!isAppDestination(destination.href)) return;
  navigating = true;
  window.dispatchEvent(new CustomEvent('beaw-app-navigation', { detail: { pending: true } }));
  try {
    if (readTokens()?.access_token) {
      const { token } = await apiRequest<{ token: string }>('/auth/app-handoff', { method: 'POST' });
      if (!token) throw new Error('ส่งต่อการเข้าสู่ระบบไม่สำเร็จ');
      const next = destination.pathname + destination.search + destination.hash;
      destination.pathname = '/auth/handoff';
      destination.search = '';
      destination.hash = '';
      destination.searchParams.set('token', token);
      destination.searchParams.set('next', next);
    }
    window.location.assign(destination.href);
  } catch {
    // Stay on the signed-in website so a failed handoff can be retried.
    window.dispatchEvent(new CustomEvent('beaw-app-navigation', {
      detail: { error: 'ส่งต่อการเข้าสู่ระบบไม่สำเร็จ กรุณาลองอีกครั้ง', retry: path },
    }));
  } finally { navigating = false; }
}
